export const DEX_KNOWN_ERRORS = {
    ERC20InsufficientAllowance:           '0xfb8f41b2', // Equals to PoolTrancheInsufficientAssetAllowance
    ERC20InsufficientBalance:             '0xe450d38c', // Equals to PoolTrancheInsufficientAssetBalance
    PoolTrancheDepositBelowMinValue:      '0x7f0a3257', // The deposit is below the minimum allowed value
    PriceStoreNoPriceForDeliverable:      '0xba390d1d', // Can't use that asset because it's price is unknown
    PoolTrancheContainsInsufficientValue: '0x5934fe86', // Insufficient value in the tranche to allow withdrawal
    PoolTrancheDepositCoolingPeriod:      '0x5fc670cd', // Withdrawal attempt too soon after deposit
    PoolTrancheWithdrawalCoolingPeriod:   '0x748e5333', // Withdrawal attempt too soon after previous withdrawal

    // Sender hasn't approved the quantity of the token required to carry out a deposit or withdrawal
    PoolTrancheInsufficientAssetAllowance: '0xa7a7693d',

    // Sender doesn't hold the quantity of the token required to carry out a deposit or withdrawal
    PoolTrancheInsufficientAssetBalance: '0x107a4b03'
} as const;

export interface DexErrorNamingDictRec {
    title: string;
    msg: string;
    msgLong: string;
    gasMsg?: string;
    gasMsgLong?: string;
    action: string;
}

export interface DexErrorNamingRec extends DexErrorNamingDictRec {
    key: keyof typeof DEX_KNOWN_ERRORS;
    selector: string;
}

const _PREFIX = 'components.widgets.dex-lp-trade-widget.';

const PART_DEX_KNOWN_ERRORS_NAMING: Readonly<Partial<Record<keyof typeof DEX_KNOWN_ERRORS, DexErrorNamingDictRec>>> = {
    ERC20InsufficientAllowance:                     {
        title:      _PREFIX + 'error_ERC20InsufficientAllowance_title',
        msg:        _PREFIX + 'error_ERC20InsufficientAllowance_msg',
        msgLong:    _PREFIX + 'error_ERC20InsufficientAllowance_msg_long',
        gasMsg:     _PREFIX + 'error_ERC20InsufficientAllowance_msg_gas',
        gasMsgLong: _PREFIX + 'error_ERC20InsufficientAllowance_msg_long_gas',
        action:     _PREFIX + 'error_ERC20InsufficientAllowance_action'
    },
    ERC20InsufficientBalance:                       {
        title:   _PREFIX + 'error_ERC20InsufficientBalance_title',
        msg:     _PREFIX + 'error_ERC20InsufficientBalance_msg',
        msgLong: _PREFIX + 'error_ERC20InsufficientBalance_msg_long',
        action:  _PREFIX + 'error_ERC20InsufficientBalance_action'
    }
};

export const DEX_KNOWN_ERRORS_NAMING: Readonly<Record<keyof typeof DEX_KNOWN_ERRORS, DexErrorNamingDictRec>> = {
    ERC20InsufficientAllowance:            PART_DEX_KNOWN_ERRORS_NAMING.ERC20InsufficientAllowance,
    ERC20InsufficientBalance:              PART_DEX_KNOWN_ERRORS_NAMING.ERC20InsufficientBalance,
    PoolTrancheDepositBelowMinValue:       {
        title:   _PREFIX + 'error_PoolTrancheDepositBelowMinValue_title',
        msg:     _PREFIX + 'error_PoolTrancheDepositBelowMinValue_msg',
        msgLong: _PREFIX + 'error_PoolTrancheDepositBelowMinValue_msg_long',
        action:  _PREFIX + 'error_PoolTrancheDepositBelowMinValue_action'
    },
    PriceStoreNoPriceForDeliverable:       {
        title:   _PREFIX + 'error_PriceStoreNoPriceForDeliverable_title',
        msg:     _PREFIX + 'error_PriceStoreNoPriceForDeliverable_msg',
        msgLong: _PREFIX + 'error_PriceStoreNoPriceForDeliverable_msg_long',
        action:  _PREFIX + 'error_PriceStoreNoPriceForDeliverable_action'
    },
    PoolTrancheContainsInsufficientValue:  {
        title:   _PREFIX + 'error_PoolTranchedContainsInsufficientValue_title',
        msg:     _PREFIX + 'error_PoolTranchedContainsInsufficientValue_msg',
        msgLong: _PREFIX + 'error_PoolTranchedContainsInsufficientValue_msg_long',
        action:  _PREFIX + 'error_PoolTranchedContainsInsufficientValue_action'
    },
    PoolTrancheDepositCoolingPeriod:       {
        title:   _PREFIX + 'error_PoolTranchedLiquidityDepositCoolingPeriod_title',
        msg:     _PREFIX + 'error_PoolTranchedLiquidityDepositCoolingPeriod_msg',
        msgLong: _PREFIX + 'error_PoolTranchedLiquidityDepositCoolingPeriod_msg_long',
        action:  _PREFIX + 'error_PoolTranchedLiquidityDepositCoolingPeriod_action'
    },
    PoolTrancheWithdrawalCoolingPeriod:    {
        title:   _PREFIX + 'error_PoolTranchedLiquidityWithdrawalCoolingPeriod_title',
        msg:     _PREFIX + 'error_PoolTranchedLiquidityWithdrawalCoolingPeriod_msg',
        msgLong: _PREFIX + 'error_PoolTranchedLiquidityWithdrawalCoolingPeriod_msg_long',
        action:  _PREFIX + 'error_PoolTranchedLiquidityWithdrawalCoolingPeriod_action'
    },
    PoolTrancheInsufficientAssetAllowance: PART_DEX_KNOWN_ERRORS_NAMING.ERC20InsufficientAllowance,
    PoolTrancheInsufficientAssetBalance:   PART_DEX_KNOWN_ERRORS_NAMING.ERC20InsufficientBalance
} as const;
